/* Copyright (c) Trimble Inc. All rights reserved. */

import { FC, PropsWithChildren, useMemo } from 'react';
import { defineCustomElements } from '@trimble-oss/moduswebcomponents/loader';
import { ModusWcThemeProvider } from '@trimble-oss/moduswebcomponents-react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import './ApplicationRoot.scss';

const DEFAULT_THEME = {
  mode: 'light',
  theme: 'modus-modern',
};
defineCustomElements();
const MODUS_THEME_STORAGE_KEY = 'modus-theme-config';
export const ApplicationRoot: FC<PropsWithChildren> = ({ children }) => {
  const queryClient = useMemo(() => new QueryClient(), []);
  const initialTheme = useMemo(() => {
    try {
      const storedTheme = localStorage.getItem(MODUS_THEME_STORAGE_KEY);

      if (storedTheme) {
        return JSON.parse(storedTheme);
      }
    } catch (error) {
      console.error('Failed to read saved theme', error);
    }

    return DEFAULT_THEME;
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <ModusWcThemeProvider initialTheme={initialTheme}>
        <div className='app-root'>{children}</div>
      </ModusWcThemeProvider>
    </QueryClientProvider>
  );
};

export default ApplicationRoot;
